import {
  darkCornflowerBlue,
  blackPearl_5,
  blueCharcoal,
  tangaroa,
  pickledBluewood,
} from '#/colors';
import { HeadedModalProps } from './HeadedModal';

export const MODAL_THEMES: Record<
  Required<HeadedModalProps>['theme'],
  {
    bgColor: string;
    headerBgColor: string;
    footerBgColor: string;
    border: string;
  }
> = {
  default: {
    bgColor: darkCornflowerBlue,
    headerBgColor: blackPearl_5,
    footerBgColor: darkCornflowerBlue,
    border: 'none',
  },
  'primary-light': {
    bgColor: darkCornflowerBlue,
    headerBgColor: darkCornflowerBlue,
    footerBgColor: darkCornflowerBlue,
    border: 'none',
  },
  'primary-dark': {
    bgColor: blueCharcoal,
    headerBgColor: tangaroa,
    footerBgColor: blueCharcoal,
    border: `none`,
  },
  'secondary-light': {
    bgColor: darkCornflowerBlue,
    headerBgColor: darkCornflowerBlue,
    footerBgColor: darkCornflowerBlue,
    border: `1px solid ${pickledBluewood}`,
  },
};
